import React from 'react';
import 'rc-slider/assets/index.css';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { debounce } from 'lodash-es';
import Slider from 'rc-slider';
import {
  faVolume,
  faVolumeLow,
  faVolumeSlash,
} from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { HoverCard } from '@components/main-components/hover-card';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { useAudioController } from '@store/audio/AudioController';
import { setVolume, toggleMute } from '@store/audio/AudioEngineHTML5';

export const VolumeButton = () => {
  const { muted, volume } = useAudioController();
  const visibleVolume = muted ? 0 : volume;

  let volumeIcon: FontAwesomeIconProps['icon'];
  if (visibleVolume === 0) {
    volumeIcon = faVolumeSlash;
  } else if (visibleVolume < 0.5) {
    volumeIcon = faVolumeLow;
  } else {
    volumeIcon = faVolume;
  }

  const onChange = debounce(value => {
    if (muted) toggleMute();
    setVolume(value);
  }, 70);

  return (
    <div className="relative flex items-center">
      <HoverCard>
        <HoverCard.Trigger>
          <IconButton
            icon={<FontAwesomeIcon icon={volumeIcon} />}
            onClick={toggleMute}
            size={32}
            iconSize={20}
          />
        </HoverCard.Trigger>
        <HoverCard.Portal>
          <HoverCard.Content className="z-audioPlayerQueueDropdown rounded-md bg-neutral900 px-1.5 py-2 shadow-sm">
            <div
              className="px-2 py-3 [&_.rc-slider-handle]:border-2 [&_.rc-slider-handle]:!border-white
              [&_.rc-slider-handle]:bg-fuchsia500 [&_.rc-slider-handle]:opacity-100 [&_.rc-slider-handle]:!shadow-[none] [&_.rc-slider-handle]:focus:!border-white [&_.rc-slider-handle]:focus:!shadow-[none] [&_.rc-slider-handle]:hover:!border-white [&_.rc-slider-handle]:hover:!shadow-[none]
              [&_.rc-slider-handle]:active:!border-white [&_.rc-slider-handle]:active:!shadow-[none] [&_.rc-slider-rail]:bg-neutral300 [&_.rc-slider-track]:bg-fuchsia500"
            >
              <Slider
                style={{ height: 111 }}
                vertical
                min={0}
                max={1}
                step={0.02}
                defaultValue={visibleVolume}
                onChange={value => {
                  const vol = typeof value === 'number' ? value : value[0];
                  onChange(vol);
                }}
                draggableTrack
              />
            </div>
          </HoverCard.Content>
        </HoverCard.Portal>
      </HoverCard>
    </div>
  );
};
